var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import jwt_decode from 'jwt-decode';
export const getNewToken = (refreshToken, API_PERSIA_URL, clientIp) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    try {
        const { data } = yield axios.post(`${API_PERSIA_URL}/graphql`, clientIp
            ? {
                query: 'mutation RefreshToken($refreshToken: String!, $clientIp: String) {  RefreshToken(input: { refresh_token: $refreshToken, clientIp: $clientIp }) {   access_token  }}',
                variables: {
                    refreshToken,
                    clientIp
                }
            }
            : {
                query: 'mutation RefreshToken($refreshToken: String!) {  RefreshToken(input: { refresh_token: $refreshToken }) {   access_token  }}',
                variables: {
                    refreshToken
                }
            }, {
            baseURL: process.env.API_PERSIA_URL
        });
        const access_token = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.RefreshToken) === null || _b === void 0 ? void 0 : _b.access_token;
        if (access_token) {
            const { exp } = jwt_decode(access_token);
            return { access_token, exp_date: exp };
        }
        else {
            return { error: (_c = data === null || data === void 0 ? void 0 : data.errors[0]) === null || _c === void 0 ? void 0 : _c.message };
        }
    }
    catch (error) {
        return { error };
    }
});
//# sourceMappingURL=refreshToken.js.map